// A first guess at the reporting currency from the browser locale, for the create-organization
// form. The region of `navigator.language` (en-US, el-GR, zh-TW, zh-Hant-TW, ...) maps to that
// region's currency; a locale without a region (or a region we do not know) falls back to EUR.
// Only a pre-fill: the user confirms or changes it.
const REGION_CURRENCY: Record<string, string> = {
  US: 'USD', CA: 'CAD', MX: 'MXN', BR: 'BRL', AR: 'ARS', CL: 'CLP', CO: 'COP', PE: 'PEN',
  GB: 'GBP', IE: 'EUR', DE: 'EUR', FR: 'EUR', ES: 'EUR', IT: 'EUR', PT: 'EUR', NL: 'EUR',
  BE: 'EUR', AT: 'EUR', GR: 'EUR', CY: 'EUR', FI: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR',
  SK: 'EUR', SI: 'EUR', HR: 'EUR', LU: 'EUR', MT: 'EUR', BG: 'BGN', CH: 'CHF', LI: 'CHF',
  SE: 'SEK', NO: 'NOK', DK: 'DKK', IS: 'ISK', PL: 'PLN', CZ: 'CZK', HU: 'HUF', RO: 'RON',
  RS: 'RSD', UA: 'UAH', TR: 'TRY', IL: 'ILS', AE: 'AED', SA: 'SAR', QA: 'QAR', KW: 'KWD',
  EG: 'EGP', MA: 'MAD', ZA: 'ZAR', NG: 'NGN', KE: 'KES', IN: 'INR', PK: 'PKR', BD: 'BDT',
  LK: 'LKR', CN: 'CNY', HK: 'HKD', TW: 'TWD', JP: 'JPY', KR: 'KRW', SG: 'SGD', MY: 'MYR',
  TH: 'THB', VN: 'VND', ID: 'IDR', PH: 'PHP', AU: 'AUD', NZ: 'NZD',
}

export const DEFAULT_CURRENCY_CODE = 'EUR'

// the locale's region subtag, wherever it sits: `sr-Latn-RS` carries a script before it, `zh-Hant-TW`
// too, `zh-cmn-Hans-CN` an extended language as well; a bare `en` has none. BCP 47 order after the
// language is extlang (3 letters) → script (4 letters) → region (2 letters or 3 digits), so the
// region is the first 2-letter / 3-digit subtag before anything else. No Intl.Locale: the
// project's TypeScript lib does not type it.
export function regionOf(lang: string): string | undefined {
  const subtags = lang.replace(/_/g, '-').split('-').slice(1)
  for (const subtag of subtags) {
    if (/^[a-zA-Z]{3,4}$/.test(subtag)) continue              // extlang or script
    if (/^([a-zA-Z]{2}|[0-9]{3})$/.test(subtag)) return subtag.toUpperCase()
    return undefined                                          // a variant or extension: no region
  }
  return undefined
}

export function guessCurrencyFromLocale(available: string[], locale?: string): string {
  const lang = locale || (typeof navigator !== 'undefined' ? navigator.language : '') || ''
  const region = regionOf(lang)
  const guess = (region && REGION_CURRENCY[region]) || DEFAULT_CURRENCY_CODE
  if (available.length === 0 || available.includes(guess)) return guess
  return available.includes(DEFAULT_CURRENCY_CODE) ? DEFAULT_CURRENCY_CODE : available[0]
}
